export default "__VITE_ASSET__qKa1yQoa__"